<template>
  <div class="base-append-button">
    <button
      :disabled="disabled"
      class="base-append-button__element"
      role="button"
      v-bind:class="{
        'has-icon-left': hasIconLeft,
        'has-icon-right': hasIconRight,
      }"
      @click="execute"
    >
      <slot><span>Text</span></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseAppendButton',
  props: {
    disabled: Boolean,
    hasIconLeft: Boolean,
    hasIconRight: Boolean,
    isLoading: Boolean,
  },
  methods: {
    execute() {
      this.$emit('execute');
    },
  },
};
</script>

<style lang="scss">
.base-append-button {
  display: flex;
  width: 100%;

  &__element {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: $color-accent-100;
    padding: 8px;
    border-radius: $border-radius-medium;
    color: $color-accent;
    cursor: pointer;
    font-size: 16px;
    min-height: 36px;
    transition: all 200ms ease;
    text-align: left;

    &:hover {
      background-color: $color-accent-pale;
    }

    &:disabled {
      box-shadow: none;
      cursor: not-allowed;
      opacity: 0.6;
    }

    &.has-icon-right {
      > .feather {
        flex: none;
        height: 16px;
        margin-left: 8px;
        width: 16px;
      }
    }

    &.has-icon-left {
      > .feather {
        flex: none;
        height: 16px;
        margin-right: 8px;
        width: 16px;
      }
    }
  }
}
</style>
